<template>
  <div class="mobile-menu-navigation__link-image">
    <img
      :key="link.imageAlt"
      v-lazy="link.image"
      :alt="link.imageAlt"
      width="64"
      height="64"
    >
  </div>
  {{ link.title }}
  <ArrowRightSmall v-if="link.links && link.links.length > 0" />
</template>

<script>
import ArrowRightSmall from '../icons/arrow-right-small'

export default {
  components: {
    ArrowRightSmall
  },
  props: {
    link: {
      type: Object,
      default: null
    },
  }
}
</script>
